export default "__VITE_ASSET__DpcSAPaH__"